<template>
  <button
    v-if="store.canToggle"
    type="button"
    data-origin-toggle
    class="inline-flex items-center gap-1 text-[12px] text-ink2 hover:text-foreground"
    :aria-label="store.mode === 'user' ? t('search.originToCenter') : t('search.originToUser')"
    @click="store.toggle()"
  >
    {{ store.mode === "user" ? t("search.originUser") : t("search.originCenter") }}
    <ArrowLeftRight class="w-3 h-3" aria-hidden="true" />
  </button>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { ArrowLeftRight } from "lucide-vue-next";
import { useDistanceOriginStore } from "../../store/distanceOrigin";

const { t } = useI18n();
const store = useDistanceOriginStore();
</script>
